import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from 'src/environments/environment';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { ConfirmOrderComponent } from './confirm-order/confirm-order.component';
import { SubmitOrderComponent } from './submit-order/submit-order.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SafePipe } from './pipes/safe.pipe';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireFunctionsModule } from "@angular/fire/functions";

@NgModule({
  declarations: [
    AppComponent,
    PurchaseOrderComponent,
    ConfirmOrderComponent,
    SubmitOrderComponent,
    SafePipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase, 'scgm-po'),
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    NgbModalModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
